import React from 'react'
import * as s from './DashboardItem.module.scss'
import Container from '../../../Common/Container'
import ProductItem from '../../ProductItem'
import { ModuleName } from '../../../../types'
import { useTranslations } from '../../../../hooks/use-translations'
import { GlobalContext } from '../../../../context/GlobalContext'
import { AppRegionEnum } from '../../../../types/app-region.enum'

const DashboardItem: React.FC = () => {
  const { t } = useTranslations()
  const { region } = React.useContext(GlobalContext)
  return (
    <div className={s.item}>
      <Container>
        <ProductItem
          moduleName={ModuleName.Dashboard}
          subtitle={t('_dashboard_subtitle')}
          text={[
            t('_dashboard_lead1'),
            t('_dashboard_lead2'),
            t('_dashboard_lead3'),
          ]}
          image={{
            id:
              region === AppRegionEnum.Ru
                ? 'signalDashboardPhone'
                : 'signaxDashboardPhone',
            alt: t('_dashboard_image_alt'),
            title: t('_dashboard_image_title'),
          }}
          itemClassName={s.productItem}
        />
      </Container>
    </div>
  )
}

export default DashboardItem
